import React from 'react'
import { Box,Container,Grid } from '@mui/material'
import EcxSurveyTopbar from './editorparts/EcxSurveyTopbar'
import EcxSurveyCanvas from './editorparts/EcxSurveyCanvas'
import EcxSurveyProperties from './editorparts/EcxSurveyProperties'
import EcxSurveyToolbar from './editorparts/EcxSurveyToolbar'
import EcxSurveyViewer from './EcxSurveyViewer'
import { useSurveyStore } from './surveyutilities/surveyStore'

function EcxSurveyEditor({loadjson=null,savejson,onSave,onPublish}) {

    const updateSurveyMetadata = useSurveyStore(state => state.updateSurveyMetadata);
    const isPreviewMode = useSurveyStore(state => state.isPreviewMode);
    return (
        <Container >
            <EcxSurveyTopbar onSave={onSave} onPublish = {onPublish} />
            <Box sx={{ flexGrow: 1 }}>
                {isPreviewMode ? (
                    <EcxSurveyViewer />
                ) : (
                    <Grid container spacing={2}>
                        <Grid size={1}>
                            <EcxSurveyToolbar  />
                        </Grid>
                        <Grid size={7}>
                            <EcxSurveyCanvas />
                        </Grid>
                        <Grid size={4}>
                            <EcxSurveyProperties/>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Container>
    )
}

export default EcxSurveyEditor